// :cow: Cosmose CONFIDENTIAL :iso:
import { initialState, ReportState } from '@med/app/home/campaign/modules/report/store/report.state';
import * as reportActions from './report.actions';

export function reducer(state = initialState, action: reportActions.All): ReportState {
  switch (action.type) {
    case reportActions.REPORT_SET_METRICS_TYPE:
      return {...state, reportMetricsType: action.payload.type};
    case reportActions.REPORT_SET_REPORT_TYPE:
      return {...state, reportType: action.payload.type};
    case reportActions.REPORT_SET_REPORT_TYPES:
      return {...state, metricsTypes: action.payload.types};
    case reportActions.REPORT_SET_DATE_RANGE:
      return {...state, reportDateRange: action.payload};
    case reportActions.REPORT_SET_AUDIENCE_SEGMENT:
      return {...state, audienceSegment: action.payload.segment};
    case reportActions.REPORT_RESET:
      return {...initialState};
    default:
      return {...state};
  }
}
